export { MatPaginatorNoTotalDisplayed } from './no-total-displayed';
export { MatPaginatorOfManyDisplayed, INDETERMINATE_MAX } from './of-many-displayed';
